// extracted by mini-css-extract-plugin
export default {"wrap":"Achivments_wrap__k0cVi","description":"Achivments_description__dYtnV","icon":"Achivments_icon__6405I"};